import React from "react";
import axios from "../../../../axios";
import * as url from "../../../../utils/url";
import LinkSharingOptions from "./LinkSharingOptions";
import { SHARE_NOTE_PUBLIC_LIBRARY_LINK } from "./shareCopy";

// TBV-951: a Library item's Copy Link sharing options — the same Sharing
// Permissions / User Must Provide as a Trivvy, stored on the Library item.
// "Anyone with this link" opens a public page that asks for the chosen detail
// and then shows the file; "Users on platform" requires login. Like Copy Link
// for Surveys / Messages / KCs, it defaults to "Anyone with this link" — items
// saved before these settings existed have no privacy and are public too.
const LibraryLinkSharingOptions = ({ libraryItem, user, onUpdated }) => {
  const planInvalid =
    user.profile && user.profile.organizationId
      ? ["001", "002"].includes(user.profile.organizationId.trivvyPlanType)
      : false;

  return (
    <LinkSharingOptions
      initialPrivacy={libraryItem.privacy || "PUBLIC"}
      initialUserIdentification={
        (libraryItem.userIdentificationOptions &&
          libraryItem.userIdentificationOptions[0]) ||
        "EMAIL"
      }
      planInvalid={planInvalid}
      publicNote={SHARE_NOTE_PUBLIC_LIBRARY_LINK}
      saveSettings={(updateData) =>
        axios.put(url.updateLibraryShareSettings(libraryItem._id), updateData)
      }
      onSaved={(updateData, res) => {
        const updatedItem = res && res.data && res.data.data;
        if (onUpdated) {
          onUpdated(
            updatedItem && updatedItem._id
              ? updatedItem
              : { _id: libraryItem._id, ...updateData }
          );
        }
      }}
    />
  );
};

export default LibraryLinkSharingOptions;
